module.exports = __webpack_public_path__ + "7a2cb3d02fa141da15e75f0f5f6d9c32.svg";